import { getAuth, onAuthStateChanged } from "firebase/auth"
import { addListnerForAuthStateVisibility, handleSignOut, initFirebase } from "./utils/fbase"
import { elementFromHtml, formatterCurrency, handleTelInputs, removeAllChildNodes } from "./utils/helper-functions"
import addNavbarBurgerListner from "./utils/navbar-burger"
import { doc, getDoc, getFirestore, setDoc, onSnapshot, deleteField } from "firebase/firestore"
import { handleProtectedRouteRedirect } from "./utils/protected-route"

initFirebase()

let isAppInitialized = false
let productsAll = {}
let cartDocRef = null
let isCartNextButtonAdded = false

document.addEventListener('DOMContentLoaded', () => {
    console.log("DOMContentLoaded")
    console.log(process.env.FBASE_APP_ID)

    addNavbarBurgerListner()
    addListnerForAuthStateVisibility()

    try {
        const btn_signout_el = document.getElementById('btn_signout')
        btn_signout_el.addEventListener('click', () => {
            btn_signout_el.classList.add('is-loading')
            handleSignOut()
            btn_signout_el.classList.remove('is-loading')
        })
    } catch (error) {
        console.error("App: Could not add click event listner to #btn_signout.", error)
    }

    onAuthStateChanged(getAuth(), (user) => {

        const cart_status_els = document.querySelectorAll('.cart .cart-status')
        let unsub = null
        if (user) {

            if (!isAppInitialized) {
                isAppInitialized = true

                cartDocRef = doc(getFirestore(), "carts", user.uid, "user_cart", user.uid)
                const productsUrl = "https://static.nearlyfamous.ca/" + process.env.FBASE_APP_ID + "/products.json"

                try {
                    const cart_container = document.getElementById('cart_container')
                    cart_container.addEventListener('submit', (event) => {

                        const el = event.target
                        if ('productUpdateCart' in el.dataset) {
                            const inputs = el.elements
                            const productKey = el.dataset.productUpdateCart
                            const qtyOrdered = inputs["quantity"].value || 0

                            if (productsAll.hasOwnProperty(productKey)) {
                                if (qtyOrdered !== 0) {
                                    setDoc(cartDocRef, {
                                        lines: {
                                            [productKey]: {
                                                key: productKey,
                                                sku: productsAll[productKey].sku,
                                                name: productsAll[productKey].name,
                                                qtyOrdered: qtyOrdered
                                            }
                                        }
                                    }, { merge: true })
                                }
                                else {
                                    setDoc(cartDocRef, {
                                        lines: {
                                            [productKey]: deleteField()
                                        }
                                    }, { merge: true })
                                }
                            }
                        }
                    })

                    cart_container.addEventListener('click', (event) => {
                        const el = event.target
                        console.log("cart_container click" + el)
                        if ('productRemoveFromCart' in el.dataset) {
                            el.classList.add('is-loading')
                            const productKey = el.dataset.productRemoveFromCart
                            setDoc(cartDocRef, {
                                lines: {
                                    [productKey]: deleteField()
                                }
                            }, { merge: true })
                        }

                    })

                } catch (error) {
                    console.error("App: Could not add click or submit event listner to #cart_container.", error)
                }


                fetch(productsUrl)
                    .then(res => res.json())
                    .then(productsDataPublic => {
                        if (typeof productsDataPublic === 'object' && !Array.isArray(productsDataPublic)) {
                            productsAll = Object.fromEntries(Object.entries(productsDataPublic).sort(([, a], [, b]) => b.position - a.position))
                        }
                        else productsAll = {}
                    })
                    .then(() => {
                        if (!Object.keys(productsAll).length) return null
                        const docRef = doc(getFirestore(), process.env.FBASE_APP_ID, "products")
                        return getDoc(docRef)
                    })
                    .then(docSnapshot => {
                        if (!Object.keys(productsAll).length || !docSnapshot.exists()) return {}
                        const data = docSnapshot.data()
                        return JSON.parse(data.json)
                    })
                    .then(productDataProtected => {
                        if (Object.keys(productDataProtected).length) {
                            Object.keys(productsAll).forEach(key => {
                                if (productDataProtected.hasOwnProperty(key)) {
                                    const data = {
                                        ...productsAll[key],
                                        ...productDataProtected[key]
                                    }
                                    productsAll[key] = data
                                }
                            })
                        }
                    })
                    .then(() => {
                        unsub = onSnapshot(cartDocRef, (doc) => {

                            if (doc.exists()) {
                                const data = doc.data()
                                const cart_container = document.getElementById('cart_container')

                                if (data.hasOwnProperty('lines') && Object.keys(data.lines).length) {
                                    const productKeys = Object.keys(data.lines).sort()
                                    const lineCount = productKeys.length

                                    cart_status_els.forEach(el => el.innerText = lineCount)

                                    removeAllChildNodes(cart_container)
                                    let grandTotal = 0
                                    let productsToRemove = {}
                                    productKeys.forEach(key => {
                                        if (productsAll.hasOwnProperty(key)) {
                                            console.log(productsAll[key])
                                            const el = document.createElement('div')
                                            el.classList.add("list-item", "has-visible-pointer-controls")
                                            el.innerHTML = `<div class="list-item-image mx-auto">
                                                <figure class="image is-96x96 is-contain"> <img src="${productsAll[key].images[0]}" alt="${productsAll[key].sku}" width="600" height="600"> </figure>
                                                </div>
                                                <div class="list-item-content ml-3">
                                                    <div class="list-item-title is-flex is-justify-content-space-between"> <span>${productsAll[key].sku}</span>${productsAll[key].specialText ? '<span class="tag">' + productsAll[key].specialText + '</span>' : ''}</div>
                                                    <div class="list-item-description"> <span>${productsAll[key].name}<br><abbr title="Minimum Order Quantity">MOQ</abbr>: ${productsAll[key].moq} | ${formatterCurrency.format(productsAll[key].price)}</span> </div>
                                                </div>
                                                <div class="list-item-controls ml-auto">
                                                <form action="POST" onsubmit="event.preventDefault()" data-product-update-cart="${key}">
                                                    <div class="is-flex is-align-items-center">
                                                        <div class="control ml-3"><input name="quantity" type="number" class="input" value="${data.lines[key].qtyOrdered}" style="width:9ch" inputmode="numeric" min="${productsAll[key].moq}" max="9999" required></div>
                                                        <div class="buttons ml-3">
                                                        <button class="button" type="submit" name="submit" title="Update"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M160-160v-80h110l-16-14q-52-46-73-105t-21-119q0-111 66.5-197.5T400-790v84q-72 26-116 88.5T240-478q0 45 17 87.5t53 78.5l10 10v-98h80v240H160Zm400-10v-84q72-26 116-88.5T720-482q0-45-17-87.5T650-648l-10-10v98h-80v-240h240v80H690l16 14q49 49 71.5 106.5T800-482q0 111-66.5 197.5T560-170Z"/></svg><span class="is-hidden-touch">Update</span></button>
                                                        <button class="button" type="button" title="Remove" data-product-remove-from-cart="${key}"><svg data-product-remove-from-cart="${key}" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg><span class="is-hidden-touch" data-product-remove-from-cart="${key}">Remove</span></button>
                                                        </div>
                                                    </div>
                                                </form>
                                                </div>
                                                `
                                            grandTotal += (productsAll[key].price * data.lines[key].qtyOrdered)
                                            cart_container.appendChild(el)
                                        }
                                        else {
                                            alert(`Product ${key} is no longer available. It will be removed from your cart.`)
                                            productsToRemove[key] = deleteField()
                                        }
                                    })

                                    const el = document.createElement('div')
                                    el.classList.add("list-item", "has-visible-pointer-controls")
                                    el.innerHTML = `<div class="list-item-controls ml-auto">
                                                        TOTAL: <strong>${formatterCurrency.format(grandTotal)}</strong>
                                                    </div>`
                                    cart_container.appendChild(el)

                                    if(!isCartNextButtonAdded) {
                                        isCartNextButtonAdded = true
                                        
                                        const cartNextBtnsHtml = `<div class="buttons is-right is-hidden-signed-out">
                                                                    <a id="cart_items_next" class="button is-link" href="/checkout-billing-info.html" title="Go to billing info">Billing info &gt;</a>
                                                                </div>`
                                        const cartNextBtnsEl = elementFromHtml(cartNextBtnsHtml)
                                        cart_container.insertAdjacentElement("afterend", cartNextBtnsEl)
                                    }


                                    if (Object.keys(productsToRemove).length) {
                                        setDoc(cartDocRef, {
                                            lines: {
                                                ...productsToRemove
                                            }
                                        }, { merge: true })
                                    }

                                }
                                else {
                                    cart_status_els.forEach(el => el.innerText = '0')

                                    removeAllChildNodes(cart_container)
                                    const el = document.createElement('div')
                                    el.classList.add("content")
                                    el.innerHTML = `<p class="has-text-centered is-size-5">Your cart is empty!</p>`
                                    cart_container.appendChild(el)
                                }
                            }
                            else {
                                setDoc(cartDocRef, {
                                    createdTimestamp: serverTimestamp(),
                                    createdTimestampLocal: Timestamp.now(),
                                    createdUser: user.uid,
                                    createdApp: process.env.FBASE_APP_ID,
                                    createdAppOrigin: location.origin || ''
                                })
                                cart_status_els.forEach(el => el.innerText = '0')
                            }
                        })
                    })
                    .catch(error => {
                        console.log(error)
                        productsAll = {}
                    })
            }
        }
        else {
            if (unsub) unsub()
            cart_status_els.forEach(el => el.innerText = '0')
            window.location = window.location.origin + "/signin.html"
        }
    })

})